import {
  call,
  ForkEffect,
  put,
  putResolve,
  select,
  takeLeading,
} from "redux-saga/effects";
import { hidePreloader } from "../../redux/preloader/actions";
import { IAppState } from "../../redux/types";
import {
  getUsersFailure,
  getUsersMobileDevicesFailure,
  getUsersMobileDevicesSussess,
  getUsersPicturesFailure,
  getUsersPicturesR,
  getUsersPicturesSuccess,
  getUsersSuccess,
} from "../../redux/users/actions";
import {
  IGetUsersMobileDevicesRequest,
  IUsersGetRequest,
  USERS,
} from "../../redux/users/types";
import { AxiosCustom } from "../../service/Axios";

export function* getUsersWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(USERS.GET_USERS_REQUEST, getUsersSaga);
}
function* getUsersSaga(action: IUsersGetRequest) {
  try {
    const state: IAppState = yield select();
    if (!state.auth.isLoggedOut) {
      const response = yield call(() => AxiosCustom.getUsers(action.payload));
      yield put(getUsersSuccess(response.data));
      yield put(getUsersPicturesR());
    }
  } catch (error) {
    yield putResolve(getUsersFailure(error));
    // yield ErrorMonitor(error as AxiosError, ErrorMessages.GET_USERS);
  }
}

export function* getUsersPictures(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(USERS.GET_USERS_PICTURE_REQUEST, getUsersPictureSaga);
}
function* getUsersPictureSaga() {
  try {
    const state: IAppState = yield select();
    if (!state.auth.isLoggedOut) {
      const response = yield call(() => AxiosCustom.getUsersPictures());
      yield put(getUsersPicturesSuccess(response.data));
    }
  } catch (error) {
    yield putResolve(getUsersPicturesFailure(error));
    // yield ErrorMonitor(error as AxiosError, ErrorMessages.GET_USERS);
  }
}

export function* getUserMobileDeviceWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    USERS.GET_USERS_MOBILE_DEVICES_REQUEST,
    getUserMobileDeviceSaga
  );
}

function* getUserMobileDeviceSaga(action: IGetUsersMobileDevicesRequest) {
  try {
    const res = yield call(() => AxiosCustom.getUsersMobileDevices());
    yield putResolve(getUsersMobileDevicesSussess(res.data));
  } catch (error) {
    yield put(hidePreloader());
    yield putResolve(getUsersMobileDevicesFailure(error));
    // yield ErrorMonitor(error as AxiosError, ErrorMessages.GET_USERS);
  }
}
